import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Diensten} from '../../dienst/diensten';
import {Dienst} from '../../dienst/dienst';

@Component({
    selector: 'zah-prestatie-diensten',
    templateUrl: './prestatie-diensten.component.html',
    styleUrls: ['./prestatie-diensten.component.scss'],
    standalone: false
})
export class PrestatieDienstenComponent {

  @Input()
  diensten: Diensten;
  @Output()
  dienstClicked: EventEmitter<Dienst> = new EventEmitter<Dienst>();

  onDienstClicked(dienst: Dienst): void {
    this.dienstClicked.emit(dienst);
  }
}
